
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormArray } from '@angular/forms';
import { Observable, of, merge } from 'rxjs';
import { tap, map, switchMap, filter, takeUntil } from 'rxjs/operators';
import { get, pickBy, omitBy, mergeWith, isNil, set } from 'lodash';
import { Store, select } from '@ngrx/store';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import { ScreenComponent } from '@core/features/screen.component';
import * as fromMaster from '@features/master/edit-0/store';


import { HttpClient } from '@angular/common/http';
import { FeatureService } from '@services/feature/feature.service';






import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;
/**
* This Component manages the presentation logic of Edit screen
*
*/
@Component({
selector: 'app-master-edit-0',
templateUrl: './master-edit-0.component.html'
})
export class MasterEdit0Component extends ScreenComponent implements OnInit {

  vars : any = {} ;
  loading$: Observable<boolean>;
  data$: Observable<any>;

residenteValues$ : Observable<any>;
estrangeiroValues$ : Observable<any>;
ddiValues$ : Observable<any>;
clienteValues$ : Observable<any>;
statusValues$ : Observable<any>;
portuguesValues$ : Observable<any>;
inglesValues$ : Observable<any>;





  keys = `Dadospessoais,info,nacionalidade,residente,estrangeiro,CPF,cpfmask,NOME,nomeinput,nascimento,datanascimento,Dadosdecontato,email,emailinput,celular,ddi,celularinput,ConfigConta,Clientes,cliente,Status,status,idioma,portugues,ingles`;


        /**
        * Default Constructor of the component
        */
        constructor(
          private featureService: FeatureService,
private httpClient: HttpClient,

          
          
          router: Router,
          store: Store<fromMaster.State>,
            activeRoute: ActivatedRoute){
            super(activeRoute, store, router);
            }

            ngOnInit() {
            super.ngOnInit();
            this.id = this.activeRoute.snapshot.data.inputs.id;
            this.form = this.createForm();
            this.parentCtx = this.getParentCtxParam();
            this.ctx = this.getScreenCtx();
            this.store.dispatch(
             fromMaster.initStateAction({ ...this.params })
            );
            this.store.dispatch(
             fromMaster.initValueAction({ ...this.getPayload(), activeRoute: this.activeRoute })
            );
            
            this.data$ = this.store.pipe(
            fromStore.selectData(this.ctx),
              tap(item => this.init(item))
            );
            this.loading$ = this.store.select(fromStore.selectLoading, this.ctx);
            this.store
            .select(fromStore.checkValidation, this.ctx)
            .pipe(filter(value => value))
            .subscribe(data => {
              const isValid = this.form.valid;
              if (!isValid) {
                this.featureService.validateForm(this.form);
              }
              this.store.dispatch(fromMaster.updateDataAction({
                ...this.getActionPayload(),
                isValid,
                value: { ...this.data }
              }));
            });
            this.form.valueChanges.pipe(
              takeUntil(this.destroy$))
              .subscribe(value => {
              this.data = mergeWith(
                { ...this.data },
                { ...value },
                (target, source) => (source === null || source instanceof Array ? source : undefined)
              );
            });
            
          }

/**
* Initialize the component by the provided data object
* @param item
*/
init(item) {
  this.data = { ...pickBy(this.data), ...omitBy(item, isNil)};
  this.featureService.patchValue(this.data, this.form);
  
  const clienteValue = get(this.data, 'cliente');
this.clienteValues$ = of(clienteValue ? [{ value: clienteValue, label: clienteValue}] : []);
const statusValue = get(this.data, 'status');
this.statusValues$ = of(statusValue ? [{ value: statusValue, label: statusValue}] : []);


  
}

getPayload() {
  return {
    ...this.params,
    ...this.ctx,
    code: this.getCode(),
    keys: this.keys,
    parentCtx: { ...this.parentCtx }
  };
}

private getCode() {
  return this.parentCtx && this.parentCtx.code
    ? this.parentCtx.code
    : this.getParamCode();
}
private getParamCode() {
  const id = this.activeRoute.snapshot.params.id;
  return id && !id.startsWith('{') ? id : undefined;
}

private getParentCtxParam() {
  const id = this.activeRoute.snapshot.params.id;
  return id && id.startsWith('{') ? JSON.parse(id) : this.parentCtx;
}

getScreenCtx() {
  return fromStore.buildScreenCtx(
    'Master',
    'Edit0',
    this.screenId,
    this.parentCtx ? this.parentCtx.roleName : null,
    this.parentCtx ? this.parentCtx.rootId : null,
    this.parentCtx && this.parentCtx.roleName
    ? this.screenId + ',' + this.parentCtx.screenId
    : null);
}

/**
* Get the data to dispatch by ngrx actions
*/
getActionPayload() {
 return {
    ...this.params,
    ctx: {...this.ctx},
    activeRoute: this.activeRoute,
    vars: { ...this.vars },
    keys: this.keys,
    data: {...this.data},
    code: this.getCode(),
  }
}


createForm(): FormGroup {
    return this.featureService.formBuilder.group({
        residente: [null, []],
        estrangeiro: [null, []],
        cpfmask: [null, []],
        nomeinput: [null, []],
        datanascimento: [null, []],
        emailinput: [null, []],
        ddi: [null, []],
        celularinput: [null, []],
        cliente: [null, []],
        status: [null, []],
        portugues: [null, []],
        ingles: [null, []],
          });
  }

getResidenteValues(): Observable<any>{
    if (!this.residenteValues$) {
      this.store.dispatch(
        fromMaster.fetchFieldPossibleValuesAction({
          ...this.params,
          field: 'residente',
          activeRoute: this.activeRoute,
          keys: undefined,
          separator: '|',
          data: this.data,
          vars: { ...this.vars, field: 'residente' }
        })
      );
      this.residenteValues$= this.store.pipe(
        fromStore.selectPossibleValues(this.ctx, 'residente')
      );
 }     return this.residenteValues$;
  }
getEstrangeiroValues(): Observable<any>{
    if (!this.estrangeiroValues$) {
      this.store.dispatch(
        fromMaster.fetchFieldPossibleValuesAction({
          ...this.params,
          field: 'estrangeiro',
          activeRoute: this.activeRoute,
          keys: undefined,
          separator: '|',
          data: this.data,
          vars: { ...this.vars, field: 'estrangeiro' }
        })
      );
      this.estrangeiroValues$= this.store.pipe(
        fromStore.selectPossibleValues(this.ctx, 'estrangeiro')
      );
 }     return this.estrangeiroValues$;
  }
getDdiValues(): Observable<any>{
    if (!this.ddiValues$) {
      this.store.dispatch(
        fromMaster.fetchFieldPossibleValuesAction({
          ...this.params,
          field: 'ddi',
          activeRoute: this.activeRoute,
          keys: undefined,
          separator: '|',
          data: this.data,
          vars: { ...this.vars, field: 'ddi' }
        })
      );
      this.ddiValues$= this.store.pipe(
        fromStore.selectPossibleValues(this.ctx, 'ddi')
      );
 }     return this.ddiValues$;
  }
getClienteValues(): Observable<any>{
      this.store.dispatch(
        fromMaster.fetchFieldPossibleValuesAction({
          ...this.params,
          field: 'cliente',
          activeRoute: this.activeRoute,
          keys: undefined,
          separator: '|',
          data: this.data,
          vars: { ...this.vars, field: 'cliente' }
        })
      );
      this.clienteValues$= this.store.pipe(
        fromStore.selectPossibleValues(this.ctx, 'cliente')
      );
    return this.clienteValues$;
  }
getStatusValues(): Observable<any>{
      this.store.dispatch(
        fromMaster.fetchFieldPossibleValuesAction({
          ...this.params,
          field: 'status',
          activeRoute: this.activeRoute,
          keys: undefined,
          separator: '|',
          data: this.data,
          vars: { ...this.vars, field: 'status' }
        })
      );
      this.statusValues$= this.store.pipe(
        fromStore.selectPossibleValues(this.ctx, 'status')
      );
    return this.statusValues$;
  }
getPortuguesValues(): Observable<any>{
    if (!this.portuguesValues$) {
      this.store.dispatch(
        fromMaster.fetchFieldPossibleValuesAction({
          ...this.params,
          field: 'portugues',
          activeRoute: this.activeRoute,
          keys: undefined,
          separator: '|',
          data: this.data,
          vars: { ...this.vars, field: 'portugues' }
        })
      );
      this.portuguesValues$= this.store.pipe(
        fromStore.selectPossibleValues(this.ctx, 'portugues')
      );
 }     return this.portuguesValues$;
  }
getInglesValues(): Observable<any>{
    if (!this.inglesValues$) {
      this.store.dispatch(
        fromMaster.fetchFieldPossibleValuesAction({
          ...this.params,
          field: 'ingles',
          activeRoute: this.activeRoute,
          keys: undefined,
          separator: '|',
          data: this.data,
          vars: { ...this.vars, field: 'ingles' }
        })
      );
      this.inglesValues$= this.store.pipe(
        fromStore.selectPossibleValues(this.ctx, 'ingles')
      );
 }     return this.inglesValues$;
  }









     isdatanascimentoReadOnly(): boolean {
      const editProfile = get(this.form.value, 'editProfile') || get(this.data, 'editProfile');
      return editProfile ;
    }










  /**
   * Navigate to an auxiliary router outlet
   * @param {object} props
   */
  navigate(feature: string,
    screen: string,
    navigationType: string,
    roleName: string): void {
      this.featureService.navigate(
        feature,
        screen,
        navigationType,
        JSON.stringify({
          ...this.ctx,
          roleName,
          rootId: this.ctx.screenId,
        }),
        this.activeRoute
      );
    }
  /**
  * Get date format from the profile
  * @param {string} temporalType
  * @param {string} datePrecision
  * @return {string} the date format
  */
  getDateFormat(temporalType: string, datePrecision?: string): string {
    return this.featureService.profileService.getDateFormat(temporalType, datePrecision);
  }
}
